<template> 
	<div class="position-relative between-footer fullchartIn-page">
		<div class="row">
			<div class="col-12"> 
			 	<div class="charTab leftMotnh bottomInc d-flex justify-content-between  scrollbar"> 
	                <!-- <a class="d-flex align-items-center justify-content-center arrowDown" href="#"><feather size="18px" type="chevron-down"></feather> </a> -->
	                <div class="d-flex align-items-center m-0 HomeChartTimeFrame">
	                    <a @click.prevent="changeInterval(val)" href="#" v-for="val in chartInterval" :class="(defaultChartInterval == val.data)?'active':''">
	                    	<span>{{val.data}}</span>
	                    </a> 
	                </div> 
		        </div>
				<div class="split  split-horizontal second-wishlist position-relative mb-3" id="charScreeen" style=" height: 100%;width: 100%">{{create_liveCandle}}
				    <div class="loader homechartloader" v-if="loading == 1"> </div> 
				    <!-- <div class="loader homechartloader" v-if="loading == 1"> </div>  -->
				    <div class="stx-dialog-container">
				        <div id="studyDialog" style="display:none;" class="stx-dialog" ref="studyDialog">
				            <h4 class="title"></h4>
				            <div @click.prevent="dismissDialog()" class="stx-btn stx-ico"><span class="stx-ico-close"></span></div>
				            <div id="inputs">
				              	<div class="inputTemplate" style="display:none">
				    	            <div class="stx-heading"></div>
				    	            <div class="stx-data"></div>
				              	</div>
				            </div>
				            <div id="outputs">
				              	<hr/>
				              	<div class="outputTemplate" style="display:none">
				    	            <div class="stx-heading"></div>
				    	            <div class="stx-color"><span></span></div>
				              	</div>
				            </div>
				            <div id="parameters"></div>
				            <div @click.prevent="createStudy()" class="stx-btn">{{$t('adchart_create')}}</div>
				        </div>
				    </div>
				    
				    <div class="chartRatio" controls>
				        <div class="d-flex calHight">
				            <div class="leftNva-inchart scrollbar">
				                <ul>
				                    <li v-for="item in 10">
				                        <a href="#"><i :class="'icon-list'+item"></i></a>
				                    </li>
				                </ul>
				            </div>
				            <div class="chartMap chartContainerSmall"  style="top: 0 ; width: 100%; overflow: hidden;" :class="type" :style="(type == 'big')?'height: 550px;':'height: 170px;'">
				                <div class="bysellGraph" style="z-index: 19;" v-if="ChartValues.Open">
					                <!-- <p><span>{{instruments[loadChart].m}}</span><span class="green"> O:</span> {{ChartValues.Open}} <span class="green">H:</span> {{ChartValues.High}} <span class="red">L:</span> {{ChartValues.Low}} <span class="red">C:</span> {{ChartValues.Close}} </p> -->
					            </div>
					            <div class="dataFailed d-flex align-items-center justify-content-center h-100" v-else-if="checkNoData()">
					            	<p>{{$t('chart_loadchartfail')}}</p> 
					            </div>
				            </div>
				        </div>
				        
				    </div>
				</div>
			</div>
		</div>
	</div> 
</template>
<script>
// import { Const } from '@/plugins/vue-provider-cache/const.mod'
var Stx = require('../../../../static/fxView/js/stx.js')
export default {
    name: 'small-Chart',
    data() {
        return {
			loading: 1,
			stxx : "",
            // "loadChart" : "EURUSD",
            intervalPeriod: 60,
            chartInterval: [
               // {'unit':1,'name':'minute',data:'1m'},
               {'unit':1,'name':'hour',data:'1h'},
               {'unit':1,'name':'day',data:'1d'},
               {'unit':1,'name':'week',data:'1W'},
               {'unit':1,'name':'month',data:'1M'}
            ],
            defaultChartInterval: '1M',
            search:'',
            searchPopUp:false,
            ShowSearchPopup:false,
            ChartValues:{Open:'',High:'',Low:'',Close:''},
            chartType:'candle',
            chartTypelist:[
                {type:'candle', value:'Candle', class:'icon-candle'},
                {type:'hollow_candle', value:'Hollow Candle', class:'hollow-candle'},
                {type:'colored_line', value:'Line', class:'icon-line'},
                {type:'mountain', value:'mountain', class:'icon-line'},
                {type:'colored_bar', value:'Bar', class:'icon-bar'},
                {type:'histogram', value:'Histogram', class:''},
                {type:'baseline_delta_mountain', value:'Baseline Mountain', class:'icon-baseLine'},
                // {type:'wave', value:'Wave', class:''}
            ],
            searchStudy:'',
            studiesAddedObjects:[],
            studiesAddedList:[],
            studies_List:{},
		}
    },
    watch:{
    	loadChart(value){
    		console.log('this.loadChart33, value====',this.loadChart33, value)
    		this.changeChart(this.loadChart33, value)
    	}
    },
    props:['loadChart33','loadChart' ,'type'],
    methods:{
    	checkNoData(){
    		let chartLength = 0 
    		try{
    			chartLength = this.stxx.chart.dataSet.length
    		}catch(e){ }
    		return (this.loading == 0) && chartLength < 2
    	},
    	create_image(){
    		var stx = this.stxx
		    var link = document.createElement('a');
		  	link.download = 'filename.jpeg';
		  	link.href = stx.chart.canvas.toDataURL("image/png")
		  	link.click();
    	},
        dismissDialog(){
            Stx.STX.DialogManager.dismissDialog()
        },
    	createStudy(){
            const div = this.$refs.studyDialog
			var a = Stx.STX.Studies.go(div, this.stxx);
            for(var type in a){
            	for(var std in a[type]){
            		_.CIQ.Studies.studyLibrary[div.study][type][std] = a[type][std]
            	}
            }
            _.CIQ.Studies.addStudy(this.stxx, div.study)
			Stx.STX.DialogManager.dismissDialog()
		},
        addStudie(studie){
            var _that =  this
            var study = studie
            if(!_that.stxx || !_that.stxx.chart.dataSet) return;
            if(_.CIQ.Studies.studyLibrary[study] && _.CIQ.Studies.studyLibrary[study].name) window._.$$("studyDialog").querySelectorAll(".title")[0].innerHTML=_that.stxx.translateIf(_.CIQ.Studies.studyLibrary[study].name);
            else window._.$$("studyDialog").querySelectorAll(".title")[0].innerHTML=study.capitalize();
            Stx.STX.Studies.studyDialog(_that.stxx, study, window._.$$("studyDialog"));
            var delay=Stx.STX.ipad?400:0;  // so that ipad doesn't register taps from menu selection on dialog
            setTimeout(function(){
                Stx.STX.DialogManager.displayDialog("studyDialog");
            }, delay);
        },
        removeStudy(val){
        	var study;
        	for (var studyInstanceName in this.stxx.layout.studies) {
				var sd = this.stxx.layout.studies[studyInstanceName];
				if(sd.type == val){
					study = sd
				}
			}
			if(study){
				_.CIQ.Studies.removeStudy(this.stxx, study)
			}
        	this.studiesAddedObjects = this.studiesAddedObjects.filter(data => data.type != val)
        	this.studiesAddedList = this.studiesAddedList.filter(data => data != val)
        },
        ChartName(chartType){
            return this.chartTypelist.filter(val=>val.type == chartType)[0].value
        },
        changeChartType(type){
            this.chartType = type
            this.stxx.setChartType(type)
        },
        openFullscreen() {
            if(document.fullscreenElement){
                document.exitFullscreen();
            }else{
                var elem = document.getElementById("charScreeen");
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) { /* Safari */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE11 */
                    elem.msRequestFullscreen();
                }
            }
        },
        drop(ev){
            var data = ev.dataTransfer.getData("text");
            // console.log(data)
            this.changeChart(data)
        },
        dataList(value){
            var data = Object.values(value)
            try{
                if(data.length > 0 ){
                    var _that = this
                    if(this.search != ''){
                        return data.filter( (val) => {
                            return val.other.isinid.toLowerCase().includes(_that.search.toLowerCase()) 
                        })
                    }
                    else{
                        return data
                    }
                }else { return []}
            }catch(e){
               return [] 
            }
        },
   		changeChart: function(marketName,marketName1){           
            // try{alert(marketName)
            //     const _her = this
            //     _her.loading = 1

            //     // this.loadChart = marketName
            //     this.stxx.newChart(marketName, null, null, function () {
            //         _her.loading = 0
            //     });
            // } catch(e){              
            //     // console.log(e)
            // }   

             try{
                const _her = this
                _her.loading = 1

                this.loadChart = marketName1
                this.search = ''
                _her.stxx.chart.symbolDisplay= marketName1;
                this.stxx.newChart(marketName, null, null, function () {
                    _her.loading = 0
                    _her.stxx.chart.symbolDisplay= marketName1;
                });
            } catch(e){              
                // console.log(e)
            }            
        },
		changeInterval: function(value){
			if(this.defaultChartInterval == value.data){
				return
			}
			this.defaultChartInterval = value.data;
			var intval = value.unit
			var tUnit = value.name
			if(tUnit == "hour"){
				intval = intval*60;
				tUnit = "minute";
			}
			this.stxx.setPeriodicity({period:1, interval:intval, timeUnit:tUnit});
		},
		initalizeChart: function(){
			this.stxx = new window._.CIQ.ChartEngine( {
				   container: window._.$$$(".chartContainerSmall"), 
				   allowScrollFuture: false, 
				   allowScrollPast: false, 
				   layout:{"candleWidth": 10, "crosshair":false, allowScrollFuture: false, allowScrollPast: false}
				}
			);
			if(this.stxx.controls.chartControls){
				// stxx.controls.chartControls.style.display="block";        // use this line to enable the controls
				this.stxx.controls.chartControls.style.display="none";        // use this line to disable the controls
			}
			this.stxx.chart.xAxis.displayGridLines=false;
			this.stxx.chart.yAxis.displayGridLines=false;
			this.stxx.setStyle("stx_grid","color", '#dedede');
			this.stxx.setStyle("stx_grid_dark","color", '#dedede');

			if(this.type == 'big'){
				this.stxx.setChartType('candle');
			}else{
				this.stxx.setChartType('mountain');
			}
			this.stxx.setStyle("stx_candle_up","color", '#25c16f');                
			this.stxx.setStyle("stx_candle_up","border-left-color", '#660000');                
			this.stxx.setStyle("stx_candle_down","color", '#e03338');
			this.stxx.setStyle("stx_candle_down","border-left-color", '#660000');
			this.stxx.setStyle("stx_candle_shadow_up","color", '#25c16f');                
			this.stxx.setStyle("stx_candle_shadow_down","color", '#e03338');

			this.stxx.setStyle("stx_xaxis_dark","color", '#6e737e'); 
			this.stxx.setStyle("stx_xaxis","color", '#6e737e'); 
			this.stxx.setStyle("stx_yaxis_dark","color", '#6e737e'); 
			this.stxx.setStyle("stx_yaxis","color", '#6e737e'); 
			this.stxx.setStyle("stx-panel-control","color", '#6e737e'); 
			this.stxx.setStyle("stx_mountain_chart","background-color", '#0bb783'); 
			this.stxx.setStyle("stx_mountain_chart","border-top-color", '#25c16f'); 

			// this.stxx.chart.xAxis.axisType="ntb";
			this.stxx.chart.yAxis.goldenRatioYAxis=true;
			this.stxx.chart.xAxis.minimumLabelWidth = 10;
            this.stxx.yaxisLeft = 20;
            this.stxx.chart.yAxis.justifyRight = false;
			this.stxx.chart.yAxis.position="right";
			// this.stxx.allowEquations = false;
			this.stxx.preferences.whitespace=0;
			this.stxx.chart.yAxis.displayBorder=false;
			this.stxx.chart.xAxis.displayBorder=false;
			this.stxx.attachQuoteFeed(__.quoteFeedSimulator,{refreshInterval:this.intervalPeriod,bufferSize:60});
			this.stxx.setMarketFactory(window._.CIQ.Market.Symbology.factory);
			// this.stxx.chart.yAxis.initialMarginTop=60;
			//this.stxx.cleanupGaps = "carry";
			// this.stxx.setPeriodicity({period:1, interval:1, timeUnit:"minute"});
			this.stxx.setPeriodicity({period:1, interval:1, timeUnit:"month"});
			const _her = this
			this.stxx.newChart(this.loadChart, null, null, function () {
				_.CIQ.Drawing.prototype.dragToDraw=true;
				_her.loading = 0
			});
			this.stxx.setMaxTicks(50);
            // _.CIQ.Studies.addStudy(this.stxx, "vol undr");
            // _.CIQ.Studies.addStudy(this.stxx, "Alligator");
            // _.CIQ.Studies.addStudy(this.stxx, "Awesome");
			this.stxx.setCandleWidth(this.stxx.layout.candleWidth*1.1);
            this.stxx.chart.allowScrollFuture = false;
            this.stxx.allowZoom = false;
			this.stxx.allowScroll = false;
			this.stxx.draw();
			// this.stxx.chart.yAxis.initialMarginTop = 50; // set default margins so they do not bump on to the legend
			// this.stxx.chart.yAxis.initialMarginBottom = 50;
			this.stxx.chart.panel.yAxis.drawCurrentPriceLabel = false;

		},
        setChartValues(open,high,low,close){
            this.ChartValues.Open = open ;
            this.ChartValues.High = high;
            this.ChartValues.Low = low;
            this.ChartValues.Close = close;
        },
    },
   	computed: {
        studyListfunc(){
            try{
                var _that = this
                var a={},b=Object.keys(window._.CIQ.Studies.studyLibrary).sort()
                b.forEach(key=>{
                    if( _that.searchStudy != '' ){
                        if(key.toLowerCase().includes(_that.searchStudy.toLowerCase())){
                            a[key] = _.CIQ.Studies.studyLibrary[key].name
                        }
                    }else{
                        a[key] = _.CIQ.Studies.studyLibrary[key].name
                    }
                })
                return a
            }catch(e){ return {} }
        },
	   	create_liveCandle(){
	        try{
	            if(this.loadChart!= ''){
	                let newQuotes = {}
	                var d = new Date() // DT is a string in ISO format, make it a Date instance
	                var getYear = d.getFullYear()
	                var getDate = d.getDate()
	                var getMonth = d.getMonth()+1
	                var getHours = d.getHours()
	                var getMins = d.getMinutes()

	                if(getMonth <= 9){ getMonth = "0"+getMonth; }
	                if(getDate <= 9){ getDate = "0"+getDate; }
	                if(getHours.toString().length <= 1){ getHours = "0"+getHours; }
	                if(getMins.toString().length <= 1){ getMins = "0"+getMins; }

	                if(this.defaultChartInterval == "1day" || this.defaultChartInterval == "1week" || this.defaultChartInterval == "1month"){
	                    newQuotes.DT = getYear+"-"+getMonth+"-"+getDate+" "+"00:00:00"
	                }else{
	                    newQuotes.DT = getYear+"-"+getMonth+"-"+getDate+" "+getHours+":"+getMins+":00";
	                }
	                let LTP   = this.instruments[this.loadChart].B

	                let open  = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Close                    
	                let high  = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].High
	                let low    = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Low
	                let Volume    = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Volume                    
	                let close =  this.instruments[this.loadChart].B

                    this.setChartValues(this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Open,high,low,this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Close)
	                if(low != 0 && low != NaN){                                    
	                    if(LTP > high){ high= LTP; }
	                    if(LTP < low){ low= LTP; }
                        this.setChartValues(open,high,low,close);                    
	                    newQuotes.Open=parseFloat(open);
	                    newQuotes.High=parseFloat(high);
	                    newQuotes.Low=parseFloat(low);
	                    newQuotes.Close=parseFloat(close);
	                    newQuotes.Volume=parseFloat(0);                        
	                    this.stxx.appendMasterData(newQuotes, null, {fillGaps: true});
	                }
	            }                    
	        }catch(ex){ }
	    },
	   	instruments() {
    	    try {                    
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return []
	        }
	    },
        // get_currencies(){
        //     try {
        //         this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
        //         return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
        //         .iCache.asKeysValueArrayAll()
        //     } catch (ex) {
        //         return []
        //     }
        // }
   	},
	created(){
		if(this.$route.query.market){
			this.loadChart = this.$route.query.market
		}
		const _that = this
		setTimeout(function(){ _that.initalizeChart() }, 1000);
	},
    mounted() {
        const _that = this
        $(document).on("click", function(event){
            if(!$(event.target).closest('.searchPopUp').length){
                _that.searchPopUp = false
            }
            if(!$(event.target).closest('.ShowSearchPopup').length){
                _that.ShowSearchPopup = false
            }
        });
        document.getElementById('charScreeen').addEventListener('fullscreenchange', (event) => {
            if (document.fullscreenElement) {
                event.target.classList.add("fullScreen-map")
            } else {
                event.target.classList.remove("fullScreen-map")
            }
        });
    }	
}
</script>
<style >
   @import "../../../../static/fxView/css/stx-standard.css"
   @import "../../../../static/fxView/css/stx-chart.css"
   
</style>
<style>
	/*.chartContainerSmall .chart-title{
		display: none
	}*/
</style>



// WEBPACK FOOTER //
// src/components/fxView/shared/chart.vue